export const getBirthdayCountdown = () => {
    const now = new Date();
    let birthday = new Date(now.getFullYear(), 9, 8); // Month is 0-based, so 9 = October
    
    // If birthday has passed this year, get next birthday
    if (now > birthday) {
        birthday.setFullYear(birthday.getFullYear() + 1);
    }
    
    const difference = birthday - now;
    
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if(hours < 10) { hours = '0' + hours.toString(); }
    let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    if(minutes < 10) { minutes = '0' + minutes.toString(); }
    let seconds = Math.floor((difference % (1000 * 60)) / 1000);
    if(seconds < 10) { seconds = '0' + seconds.toString(); }
    
    return {
        days,
        hours,
        minutes,
        seconds
    };
}

export const getNewYearsCountdown = () => {
    const now = new Date();
    let newYears = new Date(now.getFullYear(), 0, 1);
     // If New Year's day has passed this year, get next new year's day
     if (now > newYears) {
        newYears.setFullYear(newYears.getFullYear() + 1);
    }
    
    const difference = newYears - now;
    
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if(hours < 10) { hours = '0' + hours.toString(); }
    let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    if(minutes < 10) { minutes = '0' + minutes.toString(); }
    let seconds = Math.floor((difference % (1000 * 60)) / 1000);
    if(seconds < 10) { seconds = '0' + seconds.toString(); }
    
    return {
        days,
        hours,
        minutes,
        seconds
    };
}

export const getChristmasCountdown = () => {
    const now = new Date();
    let christmas = new Date(now.getFullYear(), 11, 25);
     // If Christmas day has passed this year, get next christmas
     if (now > christmas) {
        christmas.setFullYear(christmas.getFullYear() + 1);
    }
    
    const difference = christmas - now;
    
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if(hours < 10) { hours = '0' + hours.toString(); }
    let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    if(minutes < 10) { minutes = '0' + minutes.toString(); }
    let seconds = Math.floor((difference % (1000 * 60)) / 1000);
    if(seconds < 10) { seconds = '0' + seconds.toString(); }
    
    return {
        days,
        hours,
        minutes,
        seconds
    };
}